import type { CardDef } from '../types/cards';
import { copies, cost, science, shields, vp } from './helpers';

/** Era III (2ª edición): 40 cartas + N+2 gremios. Las manos pasan a la IZQUIERDA. */
export const AGE3_CARDS: CardDef[] = [
  // Azules
  { id: 'gardens', color: 'blue', cost: cost('CCW'), effects: [vp(5)], chainFrom: ['theater'], copies: copies(3, 3, 4) },
  { id: 'senate', color: 'blue', cost: cost('WWSO'), effects: [vp(6)], chainFrom: ['library'], copies: copies(3, 3, 5) },
  // Coste a verificar contra la copia física (fuentes públicas discrepan: SSOG vs SSSG).
  { id: 'town_hall', color: 'blue', cost: cost('SSOG'), effects: [vp(6)], copies: copies(3, 3, 6) },
  { id: 'pantheon', color: 'blue', cost: cost('CCOGPL'), effects: [vp(7)], chainFrom: ['altar'], copies: copies(3, 3, 6) },
  { id: 'palace', color: 'blue', cost: cost('WSOCGPL'), effects: [vp(8)], copies: copies(3, 3, 7) },
  // Amarillas
  {
    id: 'haven',
    color: 'yellow',
    cost: cost('WOL'),
    effects: [
      { kind: 'coinsPer', count: { kind: 'cards', colors: ['brown'] }, scopes: ['self'], amount: 1 },
      { kind: 'vpPer', count: { kind: 'cards', colors: ['brown'] }, scopes: ['self'], amount: 1 },
    ],
    chainFrom: ['forum'],
    copies: copies(3, 3, 4),
  },
  {
    id: 'lighthouse',
    color: 'yellow',
    cost: cost('SG'),
    effects: [
      { kind: 'coinsPer', count: { kind: 'cards', colors: ['yellow'] }, scopes: ['self'], amount: 1 },
      { kind: 'vpPer', count: { kind: 'cards', colors: ['yellow'] }, scopes: ['self'], amount: 1 },
    ],
    chainFrom: ['caravansery'],
    copies: copies(3, 3, 6),
  },
  {
    id: 'chamber_of_commerce',
    color: 'yellow',
    cost: cost('CCP'),
    effects: [
      { kind: 'coinsPer', count: { kind: 'cards', colors: ['grey'] }, scopes: ['self'], amount: 2 },
      { kind: 'vpPer', count: { kind: 'cards', colors: ['grey'] }, scopes: ['self'], amount: 2 },
    ],
    copies: copies(3, 4, 6),
  },
  {
    id: 'arena',
    color: 'yellow',
    cost: cost('SSO'),
    effects: [
      { kind: 'coinsPer', count: { kind: 'wonderStages' }, scopes: ['self'], amount: 3 },
      { kind: 'vpPer', count: { kind: 'wonderStages' }, scopes: ['self'], amount: 1 },
    ],
    chainFrom: ['dispensary'],
    copies: copies(3, 3, 5),
  },
  {
    id: 'ludus',
    color: 'yellow',
    cost: cost('SO'),
    effects: [
      { kind: 'coinsPer', count: { kind: 'cards', colors: ['red'] }, scopes: ['self'], amount: 3 },
      { kind: 'vpPer', count: { kind: 'cards', colors: ['red'] }, scopes: ['self'], amount: 1 },
    ],
    copies: copies(3, 5, 7),
  },
  // Rojas
  { id: 'arsenal', color: 'red', cost: cost('WWOL'), effects: [shields(3)], copies: copies(3, 3, 5) },
  { id: 'siege_workshop', color: 'red', cost: cost('CCCW'), effects: [shields(3)], chainFrom: ['laboratory'], copies: copies(3, 3, 5) },
  { id: 'fortifications', color: 'red', cost: cost('OOOC'), effects: [shields(3)], chainFrom: ['walls'], copies: copies(3, 3, 7) },
  { id: 'circus', color: 'red', cost: cost('SSSO'), effects: [shields(3)], chainFrom: ['training_ground'], copies: copies(3, 4, 6) },
  { id: 'castrum', color: 'red', cost: cost('CCWP'), effects: [shields(3)], copies: copies(3, 4, 7) },
  // Verdes
  { id: 'university', color: 'green', cost: cost('WWGP'), effects: [science('tablet')], chainFrom: ['library'], copies: copies(3, 3, 4) },
  { id: 'study', color: 'green', cost: cost('WPL'), effects: [science('gear')], chainFrom: ['school'], copies: copies(3, 3, 5) },
  { id: 'lodge', color: 'green', cost: cost('CCPL'), effects: [science('compass')], chainFrom: ['dispensary'], copies: copies(3, 3, 6) },
  { id: 'academy', color: 'green', cost: cost('SSSG'), effects: [science('compass')], chainFrom: ['school'], copies: copies(3, 3, 7) },
  { id: 'observatory', color: 'green', cost: cost('OOGL'), effects: [science('gear')], chainFrom: ['laboratory'], copies: copies(3, 3, 7) },
];
